/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_CompleteInputs */

const vi_import_complete = /** @type {(inputs: Import_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import khách hàng hoàn tất`)
};

/**

* @param {Import_CompleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_complete = /** @type {((inputs?: Import_CompleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_CompleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_complete(inputs)
});